import Vue from 'vue'
import Vuex from 'vuex'

import * as api from '../../api'
//import store from '..'


Vue.use(Vuex)

export default{
	state: {
		passwordLoginBusy: false,
		passwordError: false,
		passwordLoggedIn: false,
		passwordUrl: undefined,
		passwordShowRecaptcha: false,
		passwordShowTwoFactor: false,
		passwordSuccess: false,
		passwordErrors: false,
		twoFactorBusy: false,
		twoFactorError: false,
		twoFactorErrors: undefined,
		twoFactorSuccess: false,
		passwordRedirect: true,
		termsRequired: false,
	},
	mutations: {
		loginUser (state){
			state.passwordLoginBusy = true;
		},
		loginUserSuccess (state,response){
			state.passwordLoggedIn = response.data.success;
			state.passwordShowTwoFactor = response.data.two_factor_required;
			state.passwordShowRecaptcha = response.data.show_captcha;
			state.passwordUrl = response.data.url;
			state.passwordRedirect = response.data.redirect;
			state.termsRequired = response.data.terms_acception_required
			if (!state.passwordShowRecaptcha && !state.passwordShowTwoFactor && state.passwordloggedIn && !state.termsRequired) {
				if (this.state.miniView) {
					this.state.miniViewFunction('success')
					return
				}
				//iframe login stop redirect
				else if(response.data.redirect == "false") {
					this.state.miniViewFunction('success')
					return
				}
				window.top.location.href = response.data.url;
			}
			return state;
		},
		loginUserFail (state,error){
			state.passwordLoginBusy = false;
			state.passwordShowRecaptcha = error.body.show_captcha;
			state.passwordSuccess = error.body.success;
			state.passwordErrors = error.body.errors;
			if (error.data.session_active === false) {
				state.passwordLoggedIn = false;
				state.passwordShowTwoFactor = false;
			}else{
				state.passwordError = true;
				/*
				store.commit("changeError",
					i18n.t("forgot_password.user_not_found"));
				store.commit("showError");
				*/
			}
			return state;
		},
		sendTwoFactor (state){
			state.twoFactorBusy = true;
		},
		sendTwoFactorSuccess (state,response){
			state.termsRequired = response.body.terms_acception_required
			if(response.body.success){
				state.twoFactorSuccess = true;
			}
			else{
				state.twoFactorSuccess = false;
				state.twoFactorBusy = false;
			}
		},
		sendTwoFactorFail (state,error){
			state.twoFactorBusy = false;
			if(!error.body.success && error.body.errors){
				state.twoFactorError = true;
				state.twoFactorErrors = error.body.errors;
				if(error.body.show_captcha){
					state.passwordShowRecaptcha = true;
				}
			}
			else{
				state.twoFactorError = true;
			}
		},
	},
	actions: {
		loginUser: (store, { email, password, recaptcha, twoFactorCode }) => {
			store.commit('loginUser')
			return api.loginUser(email, password, recaptcha, twoFactorCode)
				.then(
					response => {
						store.commit('loginUserSuccess',response)
						return response;
					},
					error => {
						store.commit('loginUserFail', error)
						return error;
					}
				)
		},
		sendTwoFactor: (store, { twoFactorCode, recaptcha }) => {
			store.commit('sendTwoFactor')
			return api.twoFactor(twoFactorCode, recaptcha )
				.then(
					response => {
						store.commit('sendTwoFactorSuccess',response)
						return response;
					},
					error => {
						store.commit('sendTwoFactorFail', error)
						return error;
					}
				)
		},
	},
	getters: {
		passwordLoginBusy: state => state.passwordLoginBusy,
		passwordError: state => state.passwordError,
		passwordErrors: state => state.passwordErrors,
		passwordLoggedIn: state => state.passwordLoggedIn,
		passwordUrl: state => state.passwordUrl,
		passwordShowRecaptcha: state => state.passwordShowRecaptcha,
		passwordShowTwoFactor: state => state.passwordShowTwoFactor,
		passwordRedirect: state => state.passwordRedirect,
		twoFactorBusy: state => state.twoFactorBusy,
		twoFactorError: state => state.twoFactorError,
		twoFactorErrors: state => state.twoFactorErrors,
		twoFactorSuccess: state => state.twoFactorSuccess,
		termsRequired: state => state.termsRequired,
	},
}